<!-- 库间作业列表 -->
 <template>
    <div style="display: flex;flex-direction: column;  overflow: hidden;height: calc(100vh - 85px) ; background-color: #ffffff;">
        <div style=" flex-shrink: 0;">
            <el-form class="demo-form-inline" :inline="true" ref="inventoryMoveSeach" :model="inventoryMoveSeach" 
                size="mini" label-width="100px"> 
                <el-form-item label="任务类型" prop="opType"> 
                    <el-select placeholder="请选择任务类型" v-model="inventoryMoveSeach.opType" @change="changeIsBonded">
                        <el-option v-for="item in opTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库名称" prop="ckName"> 
                    <el-select placeholder="请选择仓库" v-model="inventoryMoveSeach.ckName" clearable>
                        <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务单号" prop="billNo"> 
                    <el-input  v-model="inventoryMoveSeach.billNo" placeholder="请输入任务单号" clearable ></el-input>
                </el-form-item>
                <el-form-item label="提单号" prop="blNo"> 
                    <el-input  v-model="inventoryMoveSeach.blNo" placeholder="请输入提单号" clearable ></el-input>
                </el-form-item>
                <el-form-item label="货主" prop="ownerName"> 
                    <el-select filterable placeholder="请选择货主" v-model="inventoryMoveSeach.ownerName" clearable>
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货物名称" prop="goodsName"> 
                    <el-select class="width_100" filterable :default-first-option="true" remote :remote-method="getGoodsList"
                        placeholder="请选择货物名称" v-model="inventoryMoveSeach.goodsName" clearable>
                        <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName">
                            <span class="margin_right_20">{{ item.goodsName }}</span>
                            <span class="margin_right_20">{{ item.goodsType }}</span> 
                            <span >{{ item.hsCode }}</span> 
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="note"> 
                    <el-input  v-model="inventoryMoveSeach.note" placeholder="请输入备注" clearable ></el-input>
                </el-form-item>
                <el-form-item label="创建日期" prop="createDate"> 
                    <el-date-picker v-model="createDate" clearable value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="getCreateDate" > </el-date-picker>
                </el-form-item>
                <el-form-item label=""> 
                    <el-button size="mini" @click="resetForm">重置</el-button>
                    <el-button type="primary" size="mini" @click="wmsGetKuJianList">搜索</el-button>
                    <el-button type="primary" size="mini" @click="newMoveStock">新建移库任务单</el-button>
                    <el-button type="primary" size="mini" @click="newOwnerTransfer">新建货转任务单</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="flex:1;overflow: hidden" >
            <!-- 移库列表 -->
            <vxe-table v-if="inventoryMoveSeach.opType === '移库' " id="interWarehouseTable"  size="mini" ref="interWarehouseTable" :data="interWarehouseList" border stripe
                :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
                :radio-config="{labelField: '', highlight: true}"  height="auto">
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="billNo" title="任务单号" width="160" fixed="left">
                    <template v-slot="{ row }">
                        <el-link size="mini" type="primary" @click="wmsGetKuJianDetail(row)">{{row.billNo}}</el-link>
                    </template>
                </vxe-column>
                <vxe-column field="status" title="状态" width="90" fixed="left"></vxe-column>
                <vxe-column field="blNo" title="提单号" width="160" ></vxe-column>
                <vxe-column field="goodsName" title="货物名称" min-width="130" ></vxe-column>
                <vxe-column field="ckName" title="仓库" width="130" ></vxe-column>
                <vxe-column field="ownerName" title="货主" min-width="130" ></vxe-column>
                <vxe-column field="operator" title="单证" width="130"></vxe-column>
                <vxe-column field="createDate" title="创建日期" width="130" ></vxe-column>
                <vxe-column field="note" title="备注" min-width="140" ></vxe-column>
            </vxe-table>
            <vxe-table v-if="inventoryMoveSeach.opType === '货转' " id="ownerTransferTable"  size="mini" ref="ownerTransferTable" :data="ownerTransferList" border stripe
                :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
                :radio-config="{labelField: '', highlight: true}"  height="auto">
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="billNo" title="任务单号" width="200" fixed="left">
                    <template v-slot="{ row }">
                        <el-link size="mini" type="primary" @click="wmsGetKuJianDetail(row)">{{row.billNo}}</el-link>
                    </template>
                </vxe-column>
                <vxe-column field="status" title="状态" width="130" fixed="left"></vxe-column>
                <vxe-column field="blNo" title="提单号" width="130" ></vxe-column>
                <vxe-column field="totalQty1" title="件数1" width="130" ></vxe-column>
                <vxe-column field="totalNetWeight" title="净重" width="130" ></vxe-column>
                <vxe-column field="ckName" title="仓库" width="130" ></vxe-column>
                <vxe-column field="ownerName" title="老货主" min-width="130" ></vxe-column>
                <vxe-column field="newOwnerName" title="新货主" min-width="130" ></vxe-column>
                <vxe-column field="operator" title="单证" width="130"></vxe-column>
                <vxe-column field="createDate" title="创建日期" width="130" ></vxe-column>
                <vxe-column field="note" title="备注" min-width="130" ></vxe-column>
            </vxe-table>
        </div>
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="wmsGetKuJianListPager" size="mini">
        </vxe-pager>
    </div>
</template>
<script>
import { jumpInWarehouse, closeAllWarehouseWindows } from '@/config/jumpInWarehouse.js'
export default {
    name: 'interWarehouseList',
    components:{
    },
    watch: { 
        
    },
    data() {
        return{
            opTypeList:[
                {
                    value:'移库'
                },{
                    value:'货转'
                }
                // ,{
                //     value:'盘点'
                // }
            ],
            createDate:[],// 创建日期列表
            hasHandledToken: false, // 是否处理过token
            inventoryMoveSeach:{
                opType:'移库', // 任务类型
                billNo:'', // 任务单号
                blNo:'', // 提单号
                ckName:'', // 仓库名称
                startDate:"",
                endDate:"",
                ownerName:'',
                goodsName:"",
                note:"",// 备注
            },
            ckNameList:[],  // 仓库名称列表
            customerList:[], // 委托单位列表
            goodsList:[], // 货物名称列表
            interWarehouseList:[], // 库间作业列表
            ownerTransferList:[], // 货转列表
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 20, // 每页显示多少条数据
            },
            pageSizes:[10,15,20,50,100],
        }
    },
    created() {
        this.wmsGetKuJianList()
        this.getckNameList()
        this.getCompanyList()
    },

    mounted() {
        // 监听页面卸载事件
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    methods: {
        newMoveStock(){
            jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), 'add', 'move')
        },
        newOwnerTransfer(){
            jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), 'add', 'owner')
        },
        // 重置表单
        resetForm(){
            this.inventoryMoveSeach = {
                opType:'移库', // 任务类型
                blNo:'', // 提单号
                billNo:'' ,  // 任务单号
                ckName:'', // 仓库名称
                startDate:"",
                endDate:"",
                ownerName:'',
                goodsName:'',
                note:'',
            }
        },
        // 选择不同的任务类型
        changeIsBonded(){

        },
        // 创建日期获取
        getCreateDate(data){
            if(data === null){
                this.inventoryMoveSeach.startDate = ''
                this.inventoryMoveSeach.endDate = ''
            }else{
                this.inventoryMoveSeach.startDate = data[0]
                this.inventoryMoveSeach.endDate = data[1]
            }
        },
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
            })
        },
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取货物名称列表
        getGoodsList(value){
            // this.$api.getInUseListBy({param:value} ).then(res =>{
            this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        }, 
        // 搜索移库
        wmsGetKuJianList(){
            this.pagination.currentPage = 1
            if(this.inventoryMoveSeach.opType === '移库'){
                this.$api.wmsGetStockMoveList(this.pagination.currentPage,this.pagination.pageSize,this.inventoryMoveSeach, ).then(res =>{
                    this.interWarehouseList = res.records
                    this.pagination.total = res.total
                    this.pagination.currentPage = res.current
                    this.pagination.pageSize = res.size
                })
            }else if(this.inventoryMoveSeach.opType === '货转') {
                this.$api.wmsGetOtList(this.pagination.currentPage,this.pagination.pageSize ,this.inventoryMoveSeach).then(res =>{ 
                    this.ownerTransferList = res.records
                    this.pagination.total = res.total
                    this.pagination.currentPage = res.current
                    this.pagination.pageSize = res.size
                })
            }else if(this.inventoryMoveSeach.opType === '盘点') {

            }
        },
        // 搜索移库分页
        wmsGetKuJianListPager(){
            if(this.inventoryMoveSeach.opType === '移库'){
                this.$api.wmsGetStockMoveList(this.pagination.currentPage,this.pagination.pageSize,this.inventoryMoveSeach, ).then(res =>{
                    this.interWarehouseList = res.records
                    this.pagination.total = res.total
                    this.pagination.currentPage = res.current
                    this.pagination.pageSize = res.size
                })
            }else if(this.inventoryMoveSeach.opType === '货转') {

            }else if(this.inventoryMoveSeach.opType === '盘点') {

            }
        },
        // 查看详情
        wmsGetKuJianDetail(row){
            if(this.inventoryMoveSeach.opType === '移库'){
                jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), row.id, 'move')

            }else if(this.inventoryMoveSeach.opType === '货转') {
                jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), row.id, 'owner')

            }
        },
        handleBeforeUnload() {
            closeAllWarehouseWindows()
        },
    },
    beforeDestroy(){
        closeAllWarehouseWindows()
    },
}
</script>
<style style lang="less" scoped>
// 任务单号样式
.el-link{
    font-size: 12px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>